import { useState } from "react";
import MemberType from "../MemberType";
import TicketBody from "./TicketBody";

const PLACEHOLDER = "—";

function isPlaceholder(first, last) {
  return first === PLACEHOLDER && last === PLACEHOLDER;
}

export default function Ticket({
  firstName = "",
  lastName = "",
  memberType = "non-member",
  price = "150",
  index,
  handleRemoveTicket,
  eventId,
  membershipStatusUrl,
  onMembershipFound,
  isSelfTicket = false,
  userEmail,
  nonMemberPrice,
  userId,
  company = "",
  title = "",
  email = "",
  askSelfTicketQuestion = false,
  onSelfTicketChoice,
  isOpen = false,
  onToggleOpen,
}) {
  const showBody = isSelfTicket ? false : isOpen;
  const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);

  const handleRemoveClick = () => {
    setShowRemoveConfirm(true);
  };

  const handleRemoveConfirm = () => {
    handleRemoveTicket(index);
    setShowRemoveConfirm(false);
  };

  const handleRemoveCancel = () => {
    setShowRemoveConfirm(false);
  };

  const handleMembershipFound = (data) => {
    return onMembershipFound?.(data);
  };

  const hasSavedDetails = !isPlaceholder(firstName, lastName);
  const showEditButton = !isSelfTicket && userId == null && hasSavedDetails;
  const showRemoveButton = true;

  return (
    <div className="ticket">
      <div className="ticket__header">
        <div className="ticket__member">
          <h4 className="ticket__name">
            {isPlaceholder(firstName, lastName)
              ? `Ticket ${index + 1}`
              : `${firstName} ${lastName}`}
          </h4>
          <div className="ticket__meta">
            <MemberType type={memberType} />
            <div className="ticket__actions">
              {showEditButton && (
                <button
                  type="button"
                  className={`ticket__edit ${showBody ? "ticket__edit--open" : ""}`}
                  onClick={() => onToggleOpen?.()}
                  aria-label={showBody ? "Close" : "Edit ticket"}
                  aria-expanded={showBody}
                />
              )}
              {showRemoveButton && !showRemoveConfirm && (
                <button
                  type="button"
                  className="ticket__remove"
                  onClick={handleRemoveClick}
                  aria-label="Remove ticket"
                />
              )}
            </div>
          </div>
        </div>
        <p className="ticket__price">${price != null && price !== "" ? price : "--"}</p>
      </div>
      {showRemoveConfirm && (
        <div className="ticket__remove-confirm" role="alert">
          <span className="ticket__remove-confirm-text">Remove this ticket?</span>
          <div className="ticket__remove-confirm-actions">
            <button
              type="button"
              className="ticket__remove-confirm-cancel"
              onClick={handleRemoveCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="ticket__remove-confirm-remove"
              onClick={handleRemoveConfirm}
            >
              Remove
            </button>
          </div>
        </div>
      )}
      {showBody && (
        <TicketBody
          eventId={eventId}
          membershipStatusUrl={membershipStatusUrl}
          onMembershipFound={handleMembershipFound}
          initialEmail={email || userEmail}
          nonMemberPrice={nonMemberPrice}
          askSelfTicketQuestion={askSelfTicketQuestion}
          onSelfTicketChoice={onSelfTicketChoice}
          initialData={
            !isPlaceholder(firstName, lastName)
              ? { email: email || userEmail, first_name: firstName, last_name: lastName, company, title, member_type: memberType, price }
              : undefined
          }
        />
      )}
    </div>
  );
}
